import "./DaySchedules.html";
import "./DaySchedules.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import DaySchedulesComponentController from "./DaySchedulesComponentController";

export default class DaySchedulesComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            colorTheme: "@",
            daySchedules: "=",
            dayTypes: "<",
            staticDaySchedulesSource: "<",
        };
        this.controller = DaySchedulesComponentController;
        this.templateUrl = "/App/Components/Forms/DaySchedules/DaySchedules.html";
    }
}

module("mmManagePortal").component("irDaySchedules", new DaySchedulesComponent());
